import script from "./DraftJobListView.vue?vue&type=script&lang=ts&setup=true"
export * from "./DraftJobListView.vue?vue&type=script&lang=ts&setup=true"

import "./DraftJobListView.vue?vue&type=style&index=0&id=47ebb5e8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47ebb5e8"]])

export default __exports__